<template>
  <div class="spinner"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "PSpinner",
  props: ["primary"],
});
</script>


<style scoped>
.spinner {
  color: v-bind(primary);
  outline: none;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid v-bind(primary);
  border-top-color: rgba(0, 0, 0, 0);
  animation: spinner 0.8s linear infinite;
}
</style>

